export default {"src":"/_next/static/media/uber.b3242da0.svg","height":34,"width":101};